/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

function getModuleName(path) {
	let name = path.endsWith('index.js') ? path.substring(0, path.lastIndexOf('/')) : path;
	name = name.substring(name.lastIndexOf('/') + 1, name.length);
	name = name.includes(".") ? name.substring(0, name.indexOf('.')) : name;

	return name;
}

function getModuleList(master) {
	const rootPath = master.id.substring(0, master.id.lastIndexOf('/'));
	const children = master.children.filter((path) => path.startsWith(rootPath) && path !== module.id);
	const map = children.reduce((list, child) => ({
		...list,
		[getModuleName(child)]: `.${child.replace(rootPath, "")}`,
	}), {});

	return map;
}

function reloadModules(store, moduleList) {
	return () => {
		const modules = {};

		Object.entries(moduleList).forEach(([name, path]) => {
			// `${path}` instead of just path to avoid a webpack warning
			modules[name] = require(`${path}`).default;
		});

		store.hotUpdate({ modules });
	};
}

export { getModuleList };
export { reloadModules };
